import { render, staticRenderFns } from "./point_order.vue?vue&type=template&id=0c90472f&scoped=true&"
import script from "./point_order.vue?vue&type=script&lang=js&"
export * from "./point_order.vue?vue&type=script&lang=js&"
import style0 from "./point_order.vue?vue&type=style&index=0&id=0c90472f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c90472f",
  null
  
)

export default component.exports